import React from 'react';
import Navbar from '../Components/Navbar/OptimizedNavbar';
import NavbarMobile from '../Components/NavbarMobile/NavbarMobile';
import Demo from '../Pages/Demo/Demo';
import TitleMeta from '../Components/TitleMeta/TitleMeta';
import BotHaimpress from '../Components/BotHaimpress/BotHaimpress';
export default function IndexLayout() {

    return (
        <div className='section-bg-color'>
            <TitleMeta />
            <Navbar />
            <div className='espaciobg'>
            </div>
            <Demo />
            <NavbarMobile />
            <BotHaimpress />
        </div>
    );
}
